export enum MobileActions {
    CLOSE_BANNER = 'MOBILE_CLOSE_BANNER',
}

interface CloseBanner {
    type: typeof MobileActions.CLOSE_BANNER;
}

export type MobileActionTypes = CloseBanner;
